import { css } from 'styled-components';
import { ButtonColorMap, ButtonStateColorMap } from './types';
import { ICON_SELECTOR } from '@ardoq/icons';

const composeCssColorBlock = ({
  color,
  border,
  backgroundColor,
  iconColor,
  boxShadow,
  background,
}: ButtonStateColorMap) => css`
  ${color &&
  css`
    color: ${color};
  `};
  ${backgroundColor &&
  css`
    background-color: ${backgroundColor};
  `}
  ${background &&
  css`
    background: ${background};
  `}
  ${(iconColor || color) &&
  css`
    ${ICON_SELECTOR} {
      color: ${iconColor || color};
    }
  `}
  ${boxShadow &&
  css`
    box-shadow: ${boxShadow};
  `}
  ${border &&
  css`
    border: ${border};
  `}
`;

export const composeCssStatesColorBlock = (
  colorMap: ButtonColorMap,
  isActive?: boolean
) => css`
  ${composeCssColorBlock(colorMap.default)}
  &:hover {
    ${composeCssColorBlock(colorMap.hover)}
  }
  &:active {
    ${composeCssColorBlock(colorMap.active)}
  }
  &:disabled {
    ${composeCssColorBlock(colorMap.disabled)}
  }
  ${isActive && composeCssColorBlock(colorMap.selected || colorMap.active)}
`;
